import React from 'react'
import { WorkshopEventsViewProps } from '../WorkshopEventsView'
import { EventExpanded } from './EventExpanded'
import { EventCollapsed } from './EventCollapsed'

export interface EventListProps extends WorkshopEventsViewProps {
	// filteredEvents: Array<WorkshopEvent>
}

export function EventList(props: EventListProps) {

	// const eventComponents = props.filteredEvents
	const eventComponents = props.filterState.ranges.filteredWorkshopEvents
		.map((event, eventIndex) => {

			return props.selectedWorkshopEventId === event.EventId ? 
				<EventExpanded 
					key={eventIndex} 
					event={event} 
					onClick={props.getWorkshopEventClickHandler(event)} 
					onRegisterClick={props.onRegisterClick} 
					onCloseClick={() => props.selectWorkshopEventId(undefined)}
					registrationMessage={props.recentRegistrationMessages[event.EventId]}
					onDismissRegistrationSuccessfulMessage={props.onRegistrationMessageDismissal}
					/> : 
				<EventCollapsed 
					key={eventIndex} 
					event={event} 
					onClick={props.getWorkshopEventClickHandler(event)} 
					/>
		})

		return (
			<>
				{eventComponents}
			</>
		)
}

export default EventList